import React from "react";

const NotFound = () => {
  return (
    <div className="container mx-auto flex justify-center items-center">
      <div className="py-[300px]">
        <h1 className="font-bold text-[32px]">404, Page not found</h1>
      </div>
    </div>
  );
};

export default NotFound;
